<template>
  <tr>
    <td v-if="item.edit.$model">
      <w-input :model="item.name" />
    </td>

    <td v-else>
      {{ item.name.$model }}
    </td>

    <td v-if="item.edit.$model">
      <w-vue-select
        label-field="name"
        value-field="name"
        :model="item.schoolName"
        :ajax="true"
        :taggable="false"
        :values="options"
        @search="search"
        @input="saveId"
      />
    </td>

    <td v-else>
      {{ item.schoolName.$model }}
    </td>

    <td v-if="item.edit.$model" class="text-center">
      <button class="btn-icon mr-2 btn-light" @click="save">
        <i class="fal fa-fw fa-save" />
      </button>

      <button class="btn-icon mr-2 btn-light" @click="cancel">
        <i class="fal fa-fw fa-ban" />
      </button>
    </td>

    <td v-else class="text-center">
      <button class="btn-icon mr-2 btn-light" @click="edit">
        <i class="fal fa-fw fa-pencil" />
      </button>

      <button class="btn-icon mr-2 btn-light" @click="remove">
        <i class="fal fa-fw fa-trash" />
      </button>
    </td>
  </tr>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { schoolPickerMixin } from '@/mixins/document/schoolPicker';

// @vuese
// Rząd z pojedynczym mapowaniem
// @group Setting
export default {
  components,
  mixins: [schoolPickerMixin],
  props: {
    // Mapowanie
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      previousModel: undefined
    };
  },

  created() {
    if (this.item.currentNodeId.$model) {
      this.$store
        .dispatch('structureNode/get', this.item.currentNodeId.$model)
        .then(structureNode => this.item.schoolName.$setData(structureNode.name));
    }
  },

  methods: {
    // @vuese
    // Zapis mapowania
    save() {
      if (!this.item.$validateAll().length) {
        this.item.edit.$setData(false);
        this.$emit('save');
        this.previousModel = undefined;
      }
    },
    // @vuese
    // Przechodzi w tryb edycji
    edit() {
      this.previousModel = JSON.parse(JSON.stringify({ ...this.item.$model }));
      this.item.edit.$setData(true);
    },
    // @vuese
    // Anuluje edycje
    cancel() {
      if (this.previousModel) {
        this.item.$setData(this.previousModel);
      }
    },
    // @vuese
    // Usuwa mapowanie
    remove() {
      this.$emit('remove', this.item.$key);
    },
    // @vuese
    // Zapisuje id do mapowania
    saveId(selectedSchool) {
      // select zrobiony na wartości z nazwy, a nie id, bo select nie trzymał nazwy szkoły
      this.item.currentNodeId.$setData(selectedSchool.id);
    }
  }
};
</script>
